'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GoogleDrive = (_temp = _class = function (_SvgIcon) {
  _inherits(GoogleDrive, _SvgIcon);

  function GoogleDrive() {
    _classCallCheck(this, GoogleDrive);

    return _possibleConstructorReturn(this, (GoogleDrive.__proto__ || Object.getPrototypeOf(GoogleDrive)).apply(this, arguments));
  }

  _createClass(GoogleDrive, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { fill: '#FBCE4B', d: 'M100.257 5h104.5l93 162.5-123.5-38.14' }),
          _react2['default'].createElement('path', { fill: '#DFB53D', d: 'M174.257 129.36l24.75 38.14h98.75' }),
          _react2['default'].createElement('path', {
            fill: '#3476DD',
            d: 'M297.757 167.5l-49.332 86.84h-191l94.332-86.84'
          }),
          _react2['default'].createElement('path', { fill: '#055BD8', d: 'M108.593 167.5l-51.168 86.84 94.332-86.84' }),
          _react2['default'].createElement('path', {
            fill: '#15A864',
            d: 'M57.425 254.34L5.92 167.5 100.256 5l30.495 124.625-22.16 37.875'
          }),
          _react2['default'].createElement('path', { fill: '#129155', d: 'M100.257 5l30.495 124.625 21.005-38.077' })
        );
      }

      return render;
    }()
  }]);

  return GoogleDrive;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 303.572 259.606'
}, _temp);
exports['default'] = GoogleDrive;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/GoogleDrive.js
// module id = 1374
// module chunks = 32